import { LocaleKeys } from '../../../../locale/translation-types'

export enum FamilyArrangementEnum {
  FA1E = 'FA1E',
  FA2E = 'FA2E'
}

export const familyArrangementEnumMapping: Record<
  FamilyArrangementEnum,
  // olLabel: the accommodation choice in words, in the local organiser's language
  { label: string; description: string; olLabel: LocaleKeys }
> = {
  FA1E: {
    label: 'FA1E',
    description: 'Un seul français dans la famille',
    olLabel: 'ol.center.enrollment.table.familyArrangement.FA1E'
  },
  FA2E: {
    label: 'FA2E',
    description: 'Deux français dans la famille',
    olLabel: 'ol.center.enrollment.table.familyArrangement.FA2E'
  }
}
